import { z } from "zod";

/**
 * HerSkin 对外 ID 只允许有限字符，避免控制字符、空白和路径片段进入日志、URL 或 DOM。
 * 这里不强制 UUID，允许服务端使用 `ses_...`、`run_...` 等可读前缀。
 */
export const StableIdSchema = z
  .string()
  .min(1)
  .max(128)
  .regex(/^[A-Za-z0-9][A-Za-z0-9._:-]*$/, "ID 包含非法字符");

export const HerSkinSessionIdSchema = StableIdSchema;
export const HerSkinRunIdSchema = StableIdSchema;
export const HerSkinMessageIdSchema = StableIdSchema;
/** Hermes 外部 ID 只在服务端 Adapter/持久化边界使用，不能作为浏览器主键。 */
export const HermesRuntimeIdSchema = z.string().min(1).max(256);
export const HermesStoredIdSchema = z.string().min(1).max(256);
export const CommandIdSchema = StableIdSchema.min(8);
export const EventIdSchema = StableIdSchema;
export const EventCursorSchema = StableIdSchema;
export const RequestIdSchema = StableIdSchema;
export const ConnectionIdSchema = StableIdSchema;
export const ErrorIdSchema = StableIdSchema;

export const IsoDateTimeSchema = z.string().datetime({ offset: true });

export type HerSkinSessionId = z.infer<typeof HerSkinSessionIdSchema>;
export type HerSkinRunId = z.infer<typeof HerSkinRunIdSchema>;
export type HerSkinMessageId = z.infer<typeof HerSkinMessageIdSchema>;
export type HermesRuntimeId = z.infer<typeof HermesRuntimeIdSchema>;
export type HermesStoredId = z.infer<typeof HermesStoredIdSchema>;
export type CommandId = z.infer<typeof CommandIdSchema>;
export type EventCursor = z.infer<typeof EventCursorSchema>;
